import styled from 'styled-components';
import { FC, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 2 1 auto;
  margin-right: ${(props) => props.theme.spacing(2)};
`;

const LeftContainer: FC<Props> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default LeftContainer;
